import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { webcomponentsReady } from '@codebakery/origami/polyfills';

import { AppModule } from './app/app.module';
import { BrowserAppModule } from './app/app.browser.module';
import { decorateModuleRef } from './environment';

const { version: appVersion } = require('../package.json');

require('normalize.css/normalize.css');
require('./css/flex.css');
require('./css/query.css');
require('./css/global.css');
require('./css/viewer.css');
require('./css/icomoon.css');
require('./css/calibri.css');
require('./spritesmith-generated/sprite.css');
require('./spritesmith-generated/sprite-night.css');
require('./spritesmith-generated/sprite-checkbox.css');
require('./spritesmith-generated/sprite-checkbox-night.css');
require('./css/videogular.css');
require('./css/dark-theme-auth.css');
require('@angular/material/prebuilt-themes/deeppurple-amber.css')

// tslint:disable-next-line:no-console
console.info(`Nimbus Share App: ${ BUILD_VERSION }-${ BUILD_COMMIT }`);

// Google analytics globals
Object.defineProperty(window, 'dataLayer', {
  value: [],
});

Object.defineProperty(window, 'gtag', {
  // tslint:disable-next-line
  value: (function() { window.dataLayer.push(arguments) }),
});

declare global {
  const gtag: any
  const BUILD_COMMIT: string
  const BUILD_VERSION: string
  interface Window {
    dataLayer: any[];
  }
}

export function main(): Promise<any> {
  return platformBrowserDynamic()
    // TODO DEV_SERVER ? AppModule : BrowserAppModule
    .bootstrapModule(BrowserAppModule)
    .then(decorateModuleRef)
    .catch((err) => console.error(err));
}

webcomponentsReady().then(() => {
  main();
});
